:host {
  display: block;
  @include eon-typography();
}

* {
  box-sizing: border-box;
}

.#{$prefix}contact-list {
  position: relative;
  display: block;
  padding-top: 12px;

  @include for-size(tablet-or-smaller) {
    padding-top: 48px;
  }
}

.#{$prefix}contact-list-headline {
  font-size: $copy-font-size;
  font-weight: $font-weight-bold;
  line-height: $copy-line-height;
  text-align: left;
  color: v(contentColor);
  margin-bottom: 32px;
  word-wrap: break-word; // For EDGE 18
  word-break: break-word; // For Chrome, Safari, Firefox
  @include for-size(tablet) {
    margin-bottom: 20px;
  }
}

.#{$prefix}contact-list-content {
  position: relative;
  margin-left: -5px;
  word-wrap: break-word; // For EDGE 18
  word-break: break-word; // For Chrome, Safari, Firefox

  @include for-size(tablet) {
    -moz-column-count: 3;
    -moz-column-gap: 24px;
    -webkit-column-count: 3;
    -webkit-column-gap: 24px;
    column-count: 3;
    column-gap: 24px;
  }
}
